<script lang="ts" setup>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

const props = defineProps({
  data: Array as PropType<{
    pic: string
    title: string
    text: string
  }[]>,
  twTitle: String,
  enTitle: String,
  bg: String
})
const width = isMobile() ? 180 : 320
const x = '-' + (props.data?.length * width + 200) + 'px'

const initAni = () => {
  const gTimeLine = gsap.timeline()
  gTimeLine.fromTo(
    '.process__lists',
    {
      x: '0px'
    },
    {
      x: x,
      scrollTrigger: {
        trigger: '.process',
        start: 'top -30',
        end: 'bottom',
        scrub: true,
        pin: true
      }
    }
  )
}

defineExpose({
  initAni
});

// onMounted(() => {
//   useImagesLoaded('.process img').then(initAni)
// })
</script>

<template>
  <div class="process">
    <div class="process__pic">
      <Nimg :src="bg || './images/services/process_bg.jpg'" />
    </div>
    <Intro :subtitle="props.enTitle" :data="{
      title: props.twTitle
    }" class="white display80" />
    <div class="process__lists">
      <div class="process__lists__item" v-for="(item, index) in props.data" :key="index">
        <div class="process__lists__pic">
          <Nimg :src="item.pic" />
        </div>
        <div class="process__lists__title">Step.{{ index + 1 }}{{ item.title }}</div>
        <div class="process__lists__text">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.process {
  position: relative;
  z-index: 1;
  padding-top: toRem(150);
  padding-bottom: toRem(120);
  margin-top: toRem(175);
  margin-bottom: toRem(100);

  @include max-media(767) {
    padding-top: toRem(82);
    padding-bottom: toRem(82);
    margin-bottom: toRem(25);
    margin-top: 0;
  }

  &__pic {
    position: absolute;
    left: toRem(-24);
    top: 0;
    z-index: -1;
    width: calc(100% + toRem(48));
    height: 100%;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__lists {
    display: flex;
    position: relative;
    left: 50%;
    top: 0;
    transform: translateX(0%);
    margin-right: toRem(-200);

    &__item {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: toRem(320);
      height: toRem(320);
      margin-right: toRem(80);
      background-color: $color-white-1;
      border-radius: toRem(4);

      @include max-media(767) {
        width: toRem(180);
        height: toRem(180);
        padding: toRem(12);
      }

      &:not(:last-child) {
        &::after {
          content: '';
          position: absolute;
          right: toRem(-80);
          top: 50%;
          transform: translateY(-50%);
          width: toRem(81);
          height: toRem(16);
          background-image: url('../../../public/images/iconArrowRight5.svg');
          background-repeat: no-repeat;
        }
      }
    }

    &__pic {
      position: relative;
      width: toRem(142);
      height: toRem(142);
      margin-bottom: toRem(15);

      @include max-media(767) {
        width: toRem(72);
        height: toRem(72);
      }

      img {
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }

    &__title {
      font-size: toRem(16);
      font-weight: 700;
      line-height: 1.6;

      @include max-media(767) {
        font-size: toRem(14);
      }
    }

    &__text {
      font-size: toRem(14);
      line-height: 1.3;
      text-align: center;

      @include max-media(767) {
        font-size: toRem(12);
      }
    }
  }

  .intro {
    margin-bottom: toRem(20);

    :deep(.intro__subtitle) {}

    :deep(.intro__title) {
      margin-bottom: toRem(40);
    }
  }
}
</style>
